import React from 'react';
import PropTypes from 'prop-types';
import {downloadBlobToFile} from "../../../utils/CsvDownloadWithNulls";
import {faIcons} from "../../../utils/iconConstants";

const escapeCsvValue = (value) => {
    const str = String(value ?? '');
    if (/[",\n]/.test(str)) {
        return `"${str.replaceAll('"', '""')}"`;
    }
    return str;
};

const buildCsv = ({columns, exampleRows}) => {
    const header = columns.map(column => column.name).join(',');
    const rows = (exampleRows || []).map(row => row.map(escapeCsvValue).join(','));
    return [header, ...rows].join('\r\n');
};

const UploadTemplateHelp = ({template}) => {
    if (!template) {
        return null;
    }

    const downloadSample = () => {
        downloadBlobToFile(new Blob([buildCsv(template)], {type: 'text/csv'}), template.filename);
    };

    return (
        <div className={'upload-template-help'} data-testid={'upload-template-help'}>
            {template.exampleRows?.length > 0 &&
                <button type={'button'} className={'upload-template-download'}
                        data-testid={'download-sample-csv'} onClick={downloadSample}>
                    <i className={faIcons.download}/> Download sample CSV
                </button>
            }
            {template.summary && <p className={'upload-template-summary'}>{template.summary}</p>}
            <table className={'upload-template-table'} data-testid={'upload-template-table'}>
                <thead>
                    <tr>
                        <th>Column</th>
                        <th>Type</th>
                        <th>Required</th>
                        <th>Notes</th>
                    </tr>
                </thead>
                <tbody>
                    {template.columns.map(column => (
                        <tr key={column.name}>
                            <td>{column.name}</td>
                            <td>{column.type}</td>
                            <td>{column.required ? 'Yes' : 'No'}</td>
                            <td>{column.notes}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

UploadTemplateHelp.propTypes = {
    template: PropTypes.shape({
        filename: PropTypes.string,
        summary: PropTypes.string,
        columns: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string,
            type: PropTypes.string,
            required: PropTypes.bool,
            notes: PropTypes.string,
        })),
        exampleRows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
    }),
};

export default UploadTemplateHelp;
